"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunicationPagePlain = void 0;
var React = require("react");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../Types");
var components_1 = require("@athena-portal/components");
var SupportPortalTemplates_1 = require("../SupportPortalTemplates");
var CommunicationPagePlain = /** @class */ (function (_super) {
    __extends(CommunicationPagePlain, _super);
    function CommunicationPagePlain(props) {
        var _this = _super.call(this, props) || this;
        _this.supportPortalTemplates = new SupportPortalTemplates_1.SupportPortalTemplates();
        return _this;
    }
    CommunicationPagePlain.prototype.componentDidMount = function () {
        if (this.supportPortalTemplates.userHasRole(["Administrator", "Claims_Handler", "Fraud", "CSR_Lead", "CSR"])) {
            this.supportPortalService.getCommunicationWithContent(this.props.params.id).subscribe(function (communicationWithContent) {
                if (communicationWithContent && communicationWithContent.contentHTML) {
                    document.open();
                    document.write(communicationWithContent.contentHTML);
                    document.title = communicationWithContent.subject;
                    document.close();
                }
            });
        }
    };
    CommunicationPagePlain.prototype.render = function () {
        return this.supportPortalTemplates.userHasRole(["Administrator", "Claims_Handler", "Fraud", "CSR_Lead", "CSR"]) ? null : this.supportPortalTemplates.renderErrorPage();
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], CommunicationPagePlain.prototype, "supportPortalService", void 0);
    CommunicationPagePlain = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], CommunicationPagePlain);
    return CommunicationPagePlain;
}(React.Component));
exports.CommunicationPagePlain = CommunicationPagePlain;
exports.default = (0, components_1.withRouter)(CommunicationPagePlain);
//# sourceMappingURL=CommunicationPage.js.map